import type { IconProps } from '@iheartjane/reefer';
import { Icon } from '@iheartjane/reefer';
import type { SVGProps } from 'react';

const CircledCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="320"
    height="320"
    viewBox="0 0 320 320"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M117.071 152.929L145 180.858L202.929 122.929C206.834 119.024 213.166 119.024 217.071 122.929C220.976 126.834 220.976 133.166 217.071 137.071L152.071 202.071C148.166 205.976 141.834 205.976 137.929 202.071L102.929 167.071C99.0237 163.166 99.0237 156.834 102.929 152.929C106.834 149.024 113.166 149.024 117.071 152.929Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M320 160C320 248.366 248.366 320 160 320C71.6344 320 0 248.366 0 160C0 71.6344 71.6344 0 160 0C248.366 0 320 71.6344 320 160ZM300 160C300 237.32 237.32 300 160 300C82.6801 300 20 237.32 20 160C20 82.6801 82.6801 20 160 20C237.32 20 300 82.6801 300 160Z"
      fill="currentColor"
    />
  </svg>
);

export const CircledCheckIcon = ({ ...props }: Omit<IconProps, 'icon'>) => {
  return <Icon icon={CircledCheck} {...props} />;
};
